module.exports = __webpack_public_path__ + "img/hamburger.28057003.svg";